import { createApi } from './core';

declare const healConfig: any;

function createTimeslotsApi() {
  return createApi({ baseURL: healConfig.apiBaseUrl + '/admin' });
}

export function correctCapacityForSlot(timeslotId: string): Promise<boolean> {
  return createTimeslotsApi()
    .then((api) => api.post(`/timeslot/${timeslotId}/correctUsedCapacity`))
    .then((r) => r.ok);
}
